"use strict";
import helpers from "./_helpers";

const Sponsorships = () => {
    const init = () => {
        $(document).ready(function() {
            let el = document.getElementById('sponsorships');
            if (el) {
                let $form = $(el),
                  $category = $form.find('#category'),
                  $sort = $form.find('#sort'),
                  $filters = $form.find('.filter'),
                  $dataContainer = $('#sponsorships-list');

                $filters.each(function() {
                    let $this = $(this);
                    $this.click(function() {
                        let category = $this.data('category');

                        // Update value
                        $("input[name='category']").val(category);

                        // Submit form to trigger ajax
                        $form.submit();

                        // Update visual states
                        $('.filter.active').removeClass('active');
                        $this.addClass('active');

                        if (category === "all") {
                            helpers.deleteUrlParameter('category');
                        } else {
                            helpers.setUrlParameter('category', category);
                        }
                    });
                });

                $category.change(function() {
                    let val = $(this).val();
                    // Update value
                    $("input[name='category']").val(val);
                    // Submit form to trigger ajax
                    $form.submit();
                    // Update visual states
                    $category.find('a.active').removeClass('active');
                    $form.find("a[data-category='" + val + "']").addClass('active');

                    if (val === "all") {
                        $sort.parents('.form-group').removeClass('filled');
                        $sort.parents('.form-group').removeClass('focused');
                        helpers.deleteUrlParameter('category');
                    } else {
                        helpers.setUrlParameter('category', val);
                    }
                });

                $sort.change(function() {
                    let val = $(this).val();
                    // Update value
                    $("input[name='sort']").val(val);
                    // Submit form to trigger ajax
                    $form.submit();
                    // Update visual states
                    $sort.find('a.active').removeClass('active');
                    $form.find("a[data-sort='" + val + "']").addClass('active');

                    if (val === "all") {
                        $sort.parents('.form-group').removeClass('filled');
                        $sort.parents('.form-group').removeClass('focused');
                        helpers.deleteUrlParameter('sort');
                    } else {
                        helpers.setUrlParameter('sort', val);
                    }
                });

                $dataContainer.addClass('loaded');
            }
        });
    };

    return {
        init:init
    };
};

export default Sponsorships;